
var colors = {
  teal:       '#2CB9B8',
  darkteal:   '#2D7479',
  orange:     '#FF4C33',
  darkorange: '#973D37',
  blue:       '#407FC0',
  lightblue:  '#7ECEF3',
  mauve:      '#A276B6',
  pink:       '#E56590',
  peach:      '#FAAA8C',
};

var colorSets = [
  [ 'orange', 'darkteal', 'teal', 'darkorange' ],
  [ 'blue', 'lightblue', 'mauve', 'pink', 'peach' ],
  [ 'orange', 'teal' ],
];

function pickEnough (n, list) {
  var out = [];
  for (var i = 0; i < n; i++) {
    out.push(list[i % list.length]);
  }
  return out;
}

function possiblySingular (arr) {
  return (arr.length === 1) ?  arr[0] : arr;
}

function chooseColors (config, n) {
  var selection =
    (config.colorSet) ? colorSets[config.colorSet] :
    (config.colors)   ? config.colors.split(',')   :
    colorSets[0];

  return pickEnough(n, selection.map(function (color) {
    return colors[color] ? colors[color] : 'white';
  }));
}

function commonOptions (options) {
  return Object.assign({
    legend: { display: false },
    tooltips: {
      multiKeyBackground: 'black',
    }
  }, options);
}

function add (a, b) {
  return a + b;
}

function addYLabel (m, item) {
  return m + item.yLabel;
}


//
// Line
//

function LineChart ($host, config, canvas, data) { }


//
// Bar (horizontal)
//

function BarChart ($host, config, canvas, data) {
  var chartConfig = {
    labels: data.labels,
    datasets: [{
      data: data.data,
      backgroundColor: chooseColors(config, data.labels.length),
    }]
  };

  var options = {
    legend: { display: false },
    scales: {
      xAxes: [{
        display: false,
        ticks: { beginAtZero: true }
      }],
      yAxes: [{
        barPercentage: 0.6,
        ticks: { padding: 10 },
        gridLines: {
          color: 'rgba(151, 151, 151, 0.2)',
          drawTicks: false,
          lineWidth: 1,
          zeroLineColor: 'rgba(151, 151, 151, 0.2)',
        }
      }]
    },
    tooltips: {
      displayColors: false,
      bodyFontSize: 15,
      callbacks: {
        title: function () { return ""; },
        label: function (item, d) {
          var custs  = item.yLabel != 1 ? 'customers' : 'customer';
          var tables = item.xLabel != 1 ? 'tables' : 'table';
          return item.xLabel + ' ' + tables + ' of ' + item.yLabel; // Leave this off cos its too long // + ' ' + custs;
        }
      }
    }
  };

  new Chart(canvas, { type: 'horizontalBar', data: chartConfig, options: options });
};


//
// Stacking
//

function StackedChart ($host, config, canvas, data) {

  var datasets = [];

  for (var i in data.data) {
    datasets.push({
      label: data.data[i].label,
      data: data.data[i].values,
      borderWidth: 0,
      backgroundColor: '#40404E',
      hoverBackgroundColor: colors[colorSets[config.colorSet][i]],
    });
  }

  var chartConfig = {
    labels: data.labels,
    datasets: datasets
  };

  var options = commonOptions({
    scales: {
      xAxes: [{
        stacked: true,
        gridLines: {
          display: false,
          offsetGridLines: true,
        }
      }],
      yAxes: [{
        stacked: true,
        gridLines: {
          color: 'rgba(151, 151, 151, 0.2)',
          zeroLineColor: 'rgba(151, 151, 151, 0.2)',
          drawBorder: false,
          drawTicks: false,
          offsetGridLines: true
        },
        ticks: { display: false }
      }]
    },

    tooltips: {
      position: 'nearest',
      callbacks: {
        title: function (values, d) {
          var total = values.reduce(addYLabel, 0);
          return total + " Vouchers";
        },
        label: function (item, d) {
          return " " + item.yLabel + " " + d.datasets[item.datasetIndex].label;
        }
      }
    }
  });

  new Chart(canvas, { type: 'bar', data: chartConfig, options: options });
}


//
// Pie/Donut
//

function PieChart ($host, config, canvas, data) {

  function genLabel (item, d) {
    var x = d.labels[item.index];
    var y = d.datasets[item.datasetIndex].data[item.index];
    return "  " + y + " " + x;
  }

  function genLabelAverages (item, d) {
    var x = d.labels[item.index];
    var y = d.datasets[item.datasetIndex].data[item.index];
    var t = d.datasets[item.datasetIndex].data.reduce(add, 0);
    var p = Math.round(y/t * 100) + '%';
    return "  " + y.toLocaleString() + " (" + p + ") " + x;
  }

  var chartConfig = {
    labels: data.labels,
    datasets: [{
      data: data.data,
      borderWidth: 0,
      backgroundColor: chooseColors(config, data.labels.length)
    }]
  };

  var options = commonOptions({
    cutoutPercentage: config.type === 'donut' ? 60 : 0,
    tooltips: {
      callbacks: {
        label: config.showAverages ? genLabelAverages : genLabel
      }
    }
  });

  new Chart(canvas, { type: 'pie', data: chartConfig, options: options });

}


//
// Chart Metawidget
//
// Delegates to concrete widget type implementations
//

module.exports = function ChartWidget ($host, config) {
  Chart.defaults.global.defaultFontColor  = 'white';
  Chart.defaults.global.defaultFontSize   = 13;
  Chart.defaults.global.defaultFontFamily = 'SF UI Text';

  Chart.defaults.global.tooltips.mode = 'label';
  Chart.defaults.global.tooltips.cornerRadius = 0;
  Chart.defaults.global.tooltips.xPadding = 10;
  Chart.defaults.global.tooltips.yPadding = 10;
  Chart.defaults.global.tooltips.backgroundColor = 'black';
  Chart.defaults.global.tooltips.bodySpacing = 7;
  Chart.defaults.global.tooltips.titleFontSize = 14;
  Chart.defaults.global.tooltips.titleFontStyle = 'normal';
  Chart.defaults.global.tooltips.titleMarginBottom = 10;
  Chart.defaults.global.tooltips.multiKeyBackground = 'black';

  var canvas = $host.find('canvas');
  var json   = $host.find('[data-chart-data]').text();
  var data   = {};

  try {
    var data = JSON.parse(json);
  } catch (ex) {
    console.warn("ChartWidget::init - can't parse JSON data:", ex, json);
  }

  switch (config.type) {
    case 'pie':
    case 'donut':   return PieChart($host, config, canvas, data);
    case 'bar':     return BarChart($host, config, canvas, data);
    case 'stacked': return StackedChart($host, config, canvas, data);
    default:        return LineChart($host, config, canvas, data);
  }
}

